import i18n from '@/lang/i18n'

export default {
  positions: [],
  total: 0,
  last_page: 0,
  fields: [
    {
      key: 'status',
      label: i18n.t('user.position.attribute.status'),
      sortable: true
    },
    {
      key: 'name',
      label: i18n.t('user.position.attribute.name'),
      sortable: true
    },
    {
      key: 'order',
      label: i18n.t('user.position.attribute.order'),
      sortable: true
    },
    {
      key: 'action',
      label: i18n.t('user.position.attribute.action')
    }
  ]
}



// WEBPACK FOOTER //
// ./src/store/module/position/state.js